import { render, staticRenderFns } from "./Lgx02660596852937837248804.vue?vue&type=template&id=dea4a168&"
import script from "./Lgx02660596852937837248804.vue?vue&type=script&lang=js&"
export * from "./Lgx02660596852937837248804.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports